var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      {
        staticClass: "app-main-inner-tab",
        staticStyle: {
          "flex-grow": "1",
          display: "flex",
          "flex-direction": "column"
        }
      },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%", height: "100%" },
            attrs: { type: "card" },
            on: { "tab-click": _vm.handleTabClick },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("Insurance.LiabilityInsuranceHomepage"),
                  name: "liabilityInsurance"
                }
              },
              [_c("liability-home-page", { on: { toInquiry: _vm.toInquiry } })],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("Insurance.PolicyManagement"),
                  name: "policyManagement"
                }
              },
              [
                _c("policy-grid", {
                  ref: "policyGrid",
                  attrs: { "insurance-type": 2 }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }